@if(!field()){
<code>...Loading</code>
}
@else{
  @if(field().renderType.type==='multiple'){
<label [for]="field().fieldId.toString()">{{ label }}</label>
<mat-form-field>
  <mat-chip-set>
    @for(val of formControl.value;track $index){
    <mat-chip (removed)="removeChip(val)">
      {{val}}
      <button matChipRemove [attr.aria-label]="'remove ' + val">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    }
  </mat-chip-set>

  <mat-select multiple
              [id]="field().fieldId.toString()"
              [formControl]="formControl"
              [attr.aria-labelledby]="field().fieldId.toString() + '-label'"
              [attr.aria-invalid]="formControl.invalid ? 'true' : 'false'">
    
    @for (option of options; track option) {
    <mat-option [value]="option.value">{{option.displayText}}</mat-option>
    }
  </mat-select>
  @if(formControl.errors?.['required']){
  <mat-error [attr.id]="field().fieldId.toString() + '-error'" aria-live="assertive">{{ label }} is <strong>required</strong></mat-error>
  }
</mat-form-field>
  }
  @else{
<label [for]="field().fieldId.toString()">{{ label }}</label>
<mat-form-field>

  <mat-select [id]="field().fieldId.toString()"
              [formControl]="formControl"
              [attr.aria-labelledby]="field().fieldId.toString() + '-label'"
              [attr.aria-invalid]="formControl.invalid ? 'true' : 'false'">    
    @for (option of options; track option) {
    <mat-option [value]="option.value">{{option.displayText}}</mat-option>
    }
  </mat-select>
  @if(formControl.errors?.['required']){
  <mat-error [attr.id]="field().fieldId.toString() + '-error'" aria-live="assertive">{{ label }} is <strong>required</strong></mat-error>
  }
</mat-form-field>
  }
  }
